// Whitespace Cleaner Tool — trim, collapse and tidy whitespace in text.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const whitespaceCleanerTool: Tool = {
  id: "whitespace-cleaner",
  name: () => m.wsc_tool_name(),
  description: () => m.wsc_tool_description(),
  icon: "🧼",
  basePath: "/whitespace-cleaner",
  status: "stable",
  tags: ["text", "whitespace", "trim", "developer"],
  pages: [
    {
      name: () => m.wsc_nav_main(),
      path: "/whitespace-cleaner",
      description: () => m.wsc_nav_main_desc(),
      icon: "🧼",
    },
  ],
};
